import React from 'react';
import { connect } from 'react-redux';
import { getUserPlaylists } from 'store/data/user/selectors';
import { ApplicationState, UserPlaylist } from 'types';
import ReorderRecords from 'components/ReorderRecords';
import { arrayMoveImmutable } from 'array-move';
import { Card, CardHeader, Fab, Typography } from '@mui/material';
import { reorderUserPlaylistsNow } from 'services/api/playlists';
import { isMobile } from 'helpers';
import { Icons } from 'config/icons';
import { withRouter } from 'components/shell/WithRouter';

const classes = {
	root: (theme) => ({
		my: theme.spacing(0.5),
		mr: theme.spacing(1),

		flexGrow: 1,
	}),
	header: {
		padding: '16px 0',
		margin: '0 16px',

		'& .MuiCardHeader-title': {
			fontSize: '1.6rem',
			whiteSpace: 'nowrap',
		},
		'& .MuiCardHeader-content': {
			minWidth: 0,
		},
	},
	fab: (offset: number) => ({
		position: isMobile() ? 'fixed' : ('absolute' as 'fixed'),
		bottom: `${offset + (isMobile() ? 75 : 20)}px; bottom: calc(${offset + (isMobile() ? 75 : 20)}px + env(safe-area-inset-bottom)/2)`,
		right: 30,
		zIndex: 1,
		width: 120,
	}),
};

interface ReorderPlaylistsProps {
	playlists: { [id: string]: UserPlaylist };
	reorderPlaylists: (orderedPlaylists: UserPlaylist[]) => void;
	history: any;
}

let orderedPlaylists: UserPlaylist[] = [];

const ReorderPlaylists = (props: ReorderPlaylistsProps) => {
	let { playlists, reorderPlaylists, history } = props;
	let navigate = history.navigate;

	let playlistArray = Object.values(playlists).sort((a, b) => (a.title < b.title ? -1 : 1));

	return (
		<>
			<ReorderRecords
				records={playlistArray}
				getRecordId={(playlist) => playlist.id}
				onOrderChange={(records: UserPlaylist[], oldIndex: number, newIndex: number) => {
					orderedPlaylists = arrayMoveImmutable(records, oldIndex, newIndex);
					return orderedPlaylists;
				}}
				renderTile={(playlist) => {
					let trackesKength = Object.keys(playlist?.tracks).length;

					return (
						<Card sx={classes.root}>
							<CardHeader
								sx={classes.header}
								title={<Typography noWrap>{playlist.title}</Typography>}
								subheader={trackesKength + ' Track' + (trackesKength > 1 ? 's' : '')}
							/>
						</Card>
					);
				}}
			/>
			<Fab
				color="primary"
				variant="extended"
				sx={classes.fab(10)}
				onClick={() => {
					if (orderedPlaylists.length) {
						reorderPlaylists(orderedPlaylists);
					}
					navigate(-1);
				}}
			>
				{Icons.DoneAll} &nbsp; Save
			</Fab>
		</>
	);
};

function mapStateToProps(state: ApplicationState) {
	return {
		playlists: getUserPlaylists(state),
	};
}

function mapDispatchToProps(dispatch: any) {
	return {
		reorderPlaylists: (orderedPlaylists: UserPlaylist[]) => {
			dispatch(reorderUserPlaylistsNow({ orderedPlaylists }));
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReorderPlaylists));
